export interface CustomerListKpis {
  totalCustomers: number
  activeCustomers: number
  inactiveCustomers: number
  totalBuyers: number
  openOrdersCount: number
}

export function computeCustomerListKpis(
  customers: Array<{
    status: 'active' | 'inactive'
    buyer_count?: number | null
    open_order_count?: number | null
  }>,
): CustomerListKpis {
  return customers.reduce<CustomerListKpis>(
    (acc, c) => {
      acc.totalCustomers += 1
      if (c.status === 'active') {
        acc.activeCustomers += 1
      } else {
        acc.inactiveCustomers += 1
      }
      acc.totalBuyers += Number(c.buyer_count || 0)
      acc.openOrdersCount += Number(c.open_order_count || 0)
      return acc
    },
    {
      totalCustomers: 0,
      activeCustomers: 0,
      inactiveCustomers: 0,
      totalBuyers: 0,
      openOrdersCount: 0,
    },
  )
}
